import React, { useState, useEffect, Fragment } from "react";

const QuestionsforapraiseeTab = (
  appraisalqunArray,
  handleDelappraisalqun,
  handleEditappraisalqun,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Questions For Appraisee", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = appraisalqunArray.map((el) => {
      return {
        "Questions For Appraisee": el.question,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"    
              style={{ marginRight: "10px", cursor: "pointer" }}          
              onClick={() => {
                handleEditappraisalqun(el, el.appraisalQuestionId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelappraisalqun(el.appraisalQuestionId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    appraisalqunArray,
    handleDelappraisalqun,
    handleEditappraisalqun,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default QuestionsforapraiseeTab;